module.exports = __webpack_public_path__ + "img/LOGO 2_1@2x.94beb8cc.png";